import NetworkStatusIcon from './NetworkStatusIcon'

export default NetworkStatusIcon
